<template>
  <van-cell :title="title" size="large" class="cell-item">{{
    content
  }}</van-cell>
</template>
<script>
export default {
  props: {
    title: [String],
    content: [String],
  },
};
</script>
<style lang="less" scoped>
.cell-item {
  padding: 4px 16px;
  &::after {
    border: none;
  }
}
</style>
